export default __webpack_public_path__ + "static/sz-9497ae5bf2da01aead519a1e4d6d4ba3.svg";